import { useState, useEffect, useCallback } from "react";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3000/api";
const api = axios.create({ baseURL: API_URL });
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

const Icon = {
  Plus: () => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} className="w-4 h-4"><path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16m8-8H4" /></svg>),
  Trash: () => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} className="w-4 h-4"><path strokeLinecap="round" strokeLinejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" /></svg>),
  Save: () => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} className="w-4 h-4"><path strokeLinecap="round" strokeLinejoin="round" d="M17 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V7l-4-4z" /><path strokeLinecap="round" strokeLinejoin="round" d="M17 3v4H8V3m4 14a2 2 0 100-4 2 2 0 000 4z" /></svg>),
  Edit: () => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} className="w-4 h-4"><path strokeLinecap="round" strokeLinejoin="round" d="M15.232 5.232l3.536 3.536M9 13l6.586-6.586a2 2 0 112.828 2.828L11.828 15.828a4 4 0 01-1.414.93l-3 1 1-3a4 4 0 01.93-1.414z" /></svg>),
  Check: () => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.5} className="w-4 h-4"><path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" /></svg>),
  Warning: () => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} className="w-5 h-5"><path strokeLinecap="round" strokeLinejoin="round" d="M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" /></svg>),
  Info: () => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} className="w-5 h-5"><circle cx="12" cy="12" r="10" /><path strokeLinecap="round" strokeLinejoin="round" d="M12 16v-4m0-4h.01" /></svg>),
  Calendar: () => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} className="w-4 h-4"><rect x="3" y="4" width="18" height="18" rx="2" ry="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" /></svg>),
  TurkishLira: () => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} className="w-4 h-4"><path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16M8 8h8M8 12h6" /></svg>),
};

const DEFAULT_ITEMS = [
  { name: "Temizlik", amount: 150 },
  { name: "Güvenlik", amount: 200 },
  { name: "Bakım", amount: 100 },
  { name: "Yönetim", amount: 50 },
];

export default function PaymentSettings({ tenantId, onBack }) {
  // Aidat kalemleri
  const [items, setItems] = useState(DEFAULT_ITEMS);
  const [dueDay, setDueDay] = useState(5);
  const [period, setPeriod] = useState("monthly");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [error, setError] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [newItemName, setNewItemName] = useState("");
  const [newItemAmount, setNewItemAmount] = useState("");
  const [history, setHistory] = useState([]);
  const [showHistory, setShowHistory] = useState(false);

  // Gecikme faizi
  const [feeEnabled, setFeeEnabled] = useState(false);
  const [feeRate, setFeeRate] = useState(0);
  const [savingFee, setSavingFee] = useState(false);
  const [feeSaved, setFeeSaved] = useState(false);
  const [feeEditMode, setFeeEditMode] = useState(false);
  // Yasal sınır (KMK md.20) ve limit iptali durumu
  const [capWaived, setCapWaived] = useState(false);          // süper admin izni
  const [waiverAcceptedAt, setWaiverAcceptedAt] = useState(null); // yönetici onayı
  const [showWaiverModal, setShowWaiverModal] = useState(false);
  const [waiverChecked, setWaiverChecked] = useState(false);
  const [acceptingWaiver, setAcceptingWaiver] = useState(false);

  // Yönetici iletişim bilgileri (sakin panelinde gösterim)
  const [contactEnabled, setContactEnabled] = useState(false);
  const [contactName, setContactName] = useState("");
  const [contactPhone, setContactPhone] = useState("");
  const [contactEmail, setContactEmail] = useState("");
  const [contactEditMode, setContactEditMode] = useState(false);
  const [savingContact, setSavingContact] = useState(false);
  const [contactSaved, setContactSaved] = useState(false);
    // Otomatik mesaj zamanlaması
  const [autoEnabled, setAutoEnabled] = useState(false);
  const [autoDay, setAutoDay] = useState(1);
  const [autoHour, setAutoHour] = useState(10);
  const [autoEditMode, setAutoEditMode] = useState(false);
  const [savingAuto, setSavingAuto] = useState(false);
  const [autoSaved, setAutoSaved] = useState(false);
  const [reminderLeft, setReminderLeft] = useState(null);

  // Yönetici iletişim bilgileri kaydet
  const handleSaveContact = async () => {
    if (contactEnabled) {
      if (!contactName.trim()) { setError("Gösterim açıkken ad soyad zorunludur."); return; }
      if (!contactPhone.trim() && !contactEmail.trim()) {
        setError("En az bir iletişim bilgisi girin (telefon veya e-posta)."); return;
      }
    }
    setSavingContact(true);
    try {
      await api.patch(`/tenants/${tenantId}/manager-contact`, {
        manager_contact_enabled: contactEnabled,
        manager_contact_name: contactName,
        manager_contact_phone: contactPhone,
        manager_contact_email: contactEmail,
      });
      setContactSaved(true); setContactEditMode(false); setError("");
      setTimeout(() => setContactSaved(false), 3000);
    } catch (err) {
      setError(err.response?.data?.message || "İletişim bilgileri kaydedilemedi.");
    } finally { setSavingContact(false); }
  };
    // Otomatik mesaj ayarlarını kaydet
  const handleSaveAuto = async () => {
    setSavingAuto(true);
    try {
      await api.patch(`/tenants/${tenantId}/message-settings`, {
        auto_message_enabled: autoEnabled,
        auto_message_day: Number(autoDay),
        auto_message_hour: Number(autoHour),
      });
      setAutoSaved(true); setAutoEditMode(false); setError("");
      setTimeout(() => setAutoSaved(false), 3000);
    } catch (err) {
      setError(err.response?.data?.message || "Otomatik mesaj ayarı kaydedilemedi.");
    } finally { setSavingAuto(false); }
  };

  // Daire tipleri
  const [unitTypes, setUnitTypes] = useState([]);
  const [savingTypes, setSavingTypes] = useState(false);
  const [typesSaved, setTypesSaved] = useState(false);
  const [typesEditMode, setTypesEditMode] = useState(false);
  const [newTypeName, setNewTypeName] = useState("");
  const [newTypeCoeff, setNewTypeCoeff] = useState("");

  const fetchSettings = useCallback(async () => {
    if (!tenantId) { setLoading(false); return; }
    try {
      setLoading(true);
      const [settingsRes, tenantRes, msgRes] = await Promise.all([
        api.get(`/payment-settings/${tenantId}`).catch(e => e.response?.status === 404 ? null : Promise.reject(e)),
        api.get(`/tenants/${tenantId}`),
        api.get(`/tenants/${tenantId}/message-settings`).catch(() => null)
      ]);

      if (settingsRes) {
        const data = settingsRes.data?.data || settingsRes.data;
        const single = Array.isArray(data) ? data[0] : data;
        if (single?.items) {
          setItems(typeof single.items === "string" ? JSON.parse(single.items) : single.items);
          setDueDay(single.due_day || 5);
          setPeriod(single.period || "monthly");
        }
      }

      const tenant = tenantRes.data.data;
      setFeeEnabled(tenant.late_fee_enabled || false);
      setFeeRate(tenant.late_fee_rate || 0);
      setCapWaived(tenant.late_fee_cap_waived || false);
      setWaiverAcceptedAt(tenant.late_fee_waiver_accepted_at || null);
      setContactEnabled(tenant.manager_contact_enabled || false);
      setContactName(tenant.manager_contact_name || "");
      setContactPhone(tenant.manager_contact_phone || "");
      setContactEmail(tenant.manager_contact_email || "");
      const types = typeof tenant.unit_types === "string" ? JSON.parse(tenant.unit_types) : (tenant.unit_types || []);
      setUnitTypes(types);
            if (msgRes) {
        const m = msgRes.data.data;
        setAutoEnabled(m.auto_message_enabled || false);
        setAutoDay(m.auto_message_day || 1);
        setAutoHour(m.auto_message_hour ?? 10);
        setReminderLeft(m.reminder_left ?? null);
      }
    } catch (err) {
      setError("Ayarlar yüklenirken hata oluştu.");
    } finally {
      setLoading(false);
    }
  }, [tenantId]);

  useEffect(() => { fetchSettings(); }, [fetchSettings]);

  const totalAmount = items.reduce((sum, item) => sum + Number(item.amount || 0), 0);

  // Aidat kalemleri
  const addItem = () => {
    const name = newItemName.trim();
    const amount = Number(newItemAmount);
    if (!name || isNaN(amount) || amount <= 0) return;
    if (items.find(i => i.name.toLowerCase() === name.toLowerCase())) { setError("Bu kalem adı zaten mevcut."); return; }
    setItems(prev => [...prev, { name, amount }]);
    setNewItemName(""); setNewItemAmount(""); setError("");
  };
  const removeItem = (index) => setItems(prev => prev.filter((_, i) => i !== index));
  const updateItem = (index, field, value) => setItems(prev => prev.map((item, i) => i === index ? { ...item, [field]: field === "amount" ? Number(value) : value } : item));

  const handleSave = async () => {
    if (items.length === 0) { setError("En az bir aidat kalemi eklemelisiniz."); return; }
    setSaving(true); setError("");
    try {
      await api.post("/payment-settings", { tenant_id: tenantId, period, due_day: dueDay, items, calculation_method: "per_unit", valid_from: new Date().toISOString().split("T")[0] });
      setSaved(true); setEditMode(false);
      setHistory(prev => [{ date: new Date().toLocaleString("tr-TR"), items: [...items], total: totalAmount }, ...prev.slice(0, 4)]);
      setTimeout(() => setSaved(false), 3000);
    } catch (err) {
      setError(err.response?.data?.message || "Kaydetme başarısız oldu.");
    } finally { setSaving(false); }
  };

  // Yasal sınır durumu
  const LEGAL_MAX = 5;
  const canExceedLegal = capWaived && !!waiverAcceptedAt;   // hem izin hem onay var
  const maxAllowedRate = canExceedLegal ? 100 : LEGAL_MAX;
  const rateOverLegal = parseFloat(feeRate) > LEGAL_MAX;
  // Sınır ihlali: onay yokken yasal sınır aşılmış
  const rateBlocked = rateOverLegal && !canExceedLegal;

  // Gecikme faizi kaydet
  const handleSaveFee = async () => {
    // Süper admin izin vermiş ama yönetici henüz onaylamamışsa: önce sözleşme
    if (rateOverLegal && capWaived && !waiverAcceptedAt) {
      setShowWaiverModal(true);
      return;
    }
    if (rateBlocked) {
      setError(`Kat Mülkiyeti Kanunu md. 20 gereği gecikme faizi aylık %${LEGAL_MAX}'i aşamaz. Daha yüksek bir oran için bizimle iletişime geçin.`);
      return;
    }
    setSavingFee(true);
    try {
      await api.patch(`/tenants/${tenantId}/late-fee`, { late_fee_enabled: feeEnabled, late_fee_rate: parseFloat(feeRate) });
      setFeeSaved(true); setFeeEditMode(false); setError("");
      setTimeout(() => setFeeSaved(false), 3000);
    } catch (err) {
      setError(err.response?.data?.message || "Faiz ayarı kaydedilemedi.");
    } finally { setSavingFee(false); }
  };

  // Yasal sorumluluk metnini onayla, ardından oranı kaydet
  const handleAcceptWaiver = async () => {
    setAcceptingWaiver(true);
    try {
      await api.post(`/tenants/${tenantId}/late-fee-waiver/accept`);
      setWaiverAcceptedAt(new Date().toISOString());
      setShowWaiverModal(false);
      setWaiverChecked(false);
      await api.patch(`/tenants/${tenantId}/late-fee`, { late_fee_enabled: feeEnabled, late_fee_rate: parseFloat(feeRate) });
      setFeeSaved(true); setFeeEditMode(false); setError("");
      setTimeout(() => setFeeSaved(false), 3000);
    } catch (err) {
      setError(err.response?.data?.message || "Onay kaydedilemedi.");
    } finally { setAcceptingWaiver(false); }
  };

  // Daire tipleri
  const addUnitType = () => {
    const name = newTypeName.trim();
    const coeff = parseFloat(newTypeCoeff);
    if (!name || isNaN(coeff) || coeff <= 0) return;
    if (unitTypes.find(t => t.name.toLowerCase() === name.toLowerCase())) { setError("Bu tip adı zaten mevcut."); return; }
    setUnitTypes(prev => [...prev, { name, coefficient: coeff }]);
    setNewTypeName(""); setNewTypeCoeff(""); setError("");
  };
  const removeUnitType = (index) => setUnitTypes(prev => prev.filter((_, i) => i !== index));
  const updateUnitType = (index, field, value) => setUnitTypes(prev => prev.map((t, i) => i === index ? { ...t, [field]: field === "coefficient" ? parseFloat(value) || 0 : value } : t));

  const handleSaveTypes = async () => {
    setSavingTypes(true);
    try {
      await api.patch(`/tenants/${tenantId}/unit-types`, { unit_types: unitTypes });
      setTypesSaved(true); setTypesEditMode(false);
      setTimeout(() => setTypesSaved(false), 3000);
    } catch (err) {
      setError(err.response?.data?.message || "Daire tipleri kaydedilemedi.");
    } finally { setSavingTypes(false); }
  };

  if (loading) return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center">
      <div className="text-center">
        <div className="w-10 h-10 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-3" />
        <p className="text-slate-500 text-sm">Ayarlar yükleniyor...</p>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-slate-50">

      {/* Üst Bar */}
      <div className="bg-white border-b border-slate-200 sticky top-0 z-10">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            {onBack && (
              <button onClick={onBack} className="text-slate-400 hover:text-slate-700 p-1 rounded">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} className="w-5 h-5"><path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" /></svg>
              </button>
            )}
            <div>
              <h1 className="text-lg font-bold text-slate-900">Aidat Ayarları</h1>
              <p className="text-xs text-slate-500">Kalemler, faiz ve daire tipleri</p>
            </div>
          </div>
          {!editMode ? (
            <button onClick={() => setEditMode(true)} className="flex items-center gap-1.5 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium px-3 py-2 rounded-lg">
              <Icon.Edit /> Aidat Düzenle
            </button>
          ) : (
            <div className="flex gap-2">
              <button onClick={() => { setEditMode(false); setError(""); fetchSettings(); }} className="text-sm text-slate-600 px-3 py-2 rounded-lg border border-slate-300 hover:bg-slate-50">İptal</button>
              <button onClick={handleSave} disabled={saving} className="flex items-center gap-1.5 bg-emerald-600 hover:bg-emerald-700 disabled:opacity-60 text-white text-sm font-medium px-3 py-2 rounded-lg">
                {saving ? <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" /> : <Icon.Save />}
                {saving ? "Kaydediliyor..." : "Kaydet"}
              </button>
            </div>
          )}
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 py-6 space-y-5">

        {error && (
          <div className="flex items-center gap-2 bg-red-50 border border-red-200 text-red-700 text-sm px-4 py-3 rounded-lg">
            <Icon.Warning />{error}
            <button onClick={() => setError("")} className="ml-auto text-red-400 hover:text-red-700">✕</button>
          </div>
        )}

        {/* Özet Kartlar */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
          <SummaryCard label="Toplam Aidat" value={`₺${totalAmount.toLocaleString("tr-TR")}`} color="blue" />
          <SummaryCard label="Kalem Sayısı" value={`${items.length} kalem`} color="purple" />
          <SummaryCard label="Son Ödeme Günü" value={`Her ayın ${dueDay}. günü`} color="amber" />
          <SummaryCard label="Gecikme Faizi" value={feeEnabled ? `Aktif %${feeRate}` : "Pasif"} color={feeEnabled ? "red" : "slate"} />
        </div>
                {/* ── OTOMATİK MESAJ ZAMANLAMASI ── */}
        <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
          <div className="px-5 py-4 border-b border-slate-100 flex items-center justify-between">
            <div>
              <h2 className="font-semibold text-slate-800">📅 Otomatik Aidat Mesajı</h2>
              <p className="text-xs text-slate-500 mt-0.5">Borcu olan dairelere her ay otomatik SMS ve e-posta</p>
            </div>
            {!autoEditMode ? (
              <button onClick={() => setAutoEditMode(true)} className="flex items-center gap-1.5 text-indigo-600 hover:text-indigo-800 text-sm font-medium border border-indigo-200 px-3 py-1.5 rounded-lg hover:bg-indigo-50">
                <Icon.Edit /> Düzenle
              </button>
            ) : (
              <div className="flex gap-2">
                <button onClick={() => { setAutoEditMode(false); setError(""); fetchSettings(); }} className="text-sm text-slate-600 px-3 py-1.5 rounded-lg border border-slate-300 hover:bg-slate-50">İptal</button>
                <button onClick={handleSaveAuto} disabled={savingAuto} className="flex items-center gap-1.5 bg-indigo-600 hover:bg-indigo-700 disabled:opacity-60 text-white text-sm font-medium px-3 py-1.5 rounded-lg">
                  {savingAuto ? <span className="w-3 h-3 border-2 border-white border-t-transparent rounded-full animate-spin" /> : autoSaved ? <Icon.Check /> : <Icon.Save />}
                  {savingAuto ? "Kaydediliyor..." : autoSaved ? "Kaydedildi!" : "Kaydet"}
                </button>
              </div>
            )}
          </div>

          <div className="p-5 space-y-4">
            <div className="flex items-center gap-3 p-3 bg-slate-50 rounded-lg">
              <input
                type="checkbox"
                id="auto_enabled"
                checked={autoEnabled}
                onChange={(e) => setAutoEnabled(e.target.checked)}
                disabled={!autoEditMode}
                className="w-5 h-5 cursor-pointer"
              />
              <label htmlFor="auto_enabled" className="text-sm font-medium cursor-pointer select-none">
                Otomatik mesaj gönderimi aktif
              </label>
              {!autoEditMode && (
                <span className={`ml-auto text-sm font-semibold ${autoEnabled ? "text-indigo-600" : "text-slate-400"}`}>
                  {autoEnabled ? `Her ayın ${autoDay}. günü ${String(autoHour).padStart(2, "0")}:00` : "Kapalı"}
                </span>
              )}
            </div>

            {autoEnabled && (
              <>
                <div className="grid sm:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-1.5">Gönderim Günü</label>
                    <select
                      value={autoDay}
                      onChange={(e) => setAutoDay(Number(e.target.value))}
                      disabled={!autoEditMode}
                      className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 disabled:bg-slate-50 disabled:text-slate-500"
                    >
                      {Array.from({ length: 28 }, (_, i) => i + 1).map(d => (
                        <option key={d} value={d}>Her ayın {d}. günü</option>
                      ))}
                    </select>
                    <p className="text-xs text-slate-400 mt-1">Şubat ayı kısa olduğu için en fazla 28 seçilebilir.</p>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-1.5">Gönderim Saati</label>
                    <select
                      value={autoHour}
                      onChange={(e) => setAutoHour(Number(e.target.value))}
                      disabled={!autoEditMode}
                      className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 disabled:bg-slate-50 disabled:text-slate-500"
                    >
                      {Array.from({ length: 13 }, (_, i) => i + 8).map(h => (
                        <option key={h} value={h}>{String(h).padStart(2, "0")}:00</option>
                      ))}
                    </select>
                    <p className="text-xs text-slate-400 mt-1">Sakinleri rahatsız etmemek için 08:00 - 20:00 arası.</p>
                  </div>
                </div>

                <div className="bg-indigo-50 border border-indigo-100 rounded-lg px-4 py-3 text-sm text-indigo-800">
                  <p className="font-medium mb-1">Nasıl çalışır?</p>
                  <p className="text-xs leading-relaxed">
                    Her ayın {autoDay}. günü saat {String(autoHour).padStart(2, "0")}:00 civarında,
                    <strong> ödenmemiş faturası olan</strong> dairelere ödeme linki içeren bir mesaj gider.
                    Ödemesini yapmış daireler listeye girmez. Bir daireye <strong>ayda yalnızca bir kez</strong> gönderilir.
                  </p>
                </div>
              </>
            )}

            {reminderLeft !== null && (
              <p className="text-xs text-slate-500">
                Bu ay elle gönderebileceğiniz ek hatırlatma hakkı: <strong>{reminderLeft}</strong>
              </p>
            )}
          </div>
        </div>
        {/* ── GECİKME FAİZİ AYARI ── */}
        <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
          <div className="px-5 py-4 border-b border-slate-100 flex items-center justify-between">
            <h2 className="font-semibold text-slate-800 flex items-center gap-2">
              💰 Gecikme Faizi Ayarı
            </h2>
            {!feeEditMode ? (
              <button onClick={() => setFeeEditMode(true)} className="flex items-center gap-1.5 text-orange-600 hover:text-orange-800 text-sm font-medium border border-orange-200 px-3 py-1.5 rounded-lg hover:bg-orange-50">
                <Icon.Edit /> Düzenle
              </button>
            ) : (
              <div className="flex gap-2">
                <button onClick={() => { setFeeEditMode(false); fetchSettings(); }} className="text-sm text-slate-600 px-3 py-1.5 rounded-lg border border-slate-300 hover:bg-slate-50">İptal</button>
                <button onClick={handleSaveFee} disabled={savingFee} className="flex items-center gap-1.5 bg-orange-600 hover:bg-orange-700 disabled:opacity-60 text-white text-sm font-medium px-3 py-1.5 rounded-lg">
                  {savingFee ? <span className="w-3 h-3 border-2 border-white border-t-transparent rounded-full animate-spin" /> : feeSaved ? <Icon.Check /> : <Icon.Save />}
                  {savingFee ? "Kaydediliyor..." : feeSaved ? "Kaydedildi!" : "Kaydet"}
                </button>
              </div>
            )}
          </div>
          <div className="p-5 space-y-4">
            <div className="flex items-center gap-3 p-3 bg-slate-50 rounded-lg">
              <input type="checkbox" id="fee_enabled" checked={feeEnabled} onChange={(e) => setFeeEnabled(e.target.checked)} disabled={!feeEditMode} className="w-5 h-5 cursor-pointer" />
              <label htmlFor="fee_enabled" className="text-sm font-medium cursor-pointer select-none">Gecikme Faizi Aktif</label>
              {feeEnabled && !feeEditMode && (
                <span className="ml-auto text-sm text-orange-600 font-semibold">Aylık %{feeRate} gecikme faizi uygulanıyor</span>
              )}
            </div>
            {feeEnabled && (
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1.5">Aylık Faiz Oranı (%)</label>
                <input
                  type="number"
                  value={feeRate}
                  onChange={(e) => setFeeRate(e.target.value)}
                  disabled={!feeEditMode}
                  step="0.1" min="0" max={maxAllowedRate}
                  className={`w-48 px-3 py-2 border rounded-lg text-sm focus:ring-2 disabled:bg-slate-50 disabled:text-slate-500 ${rateBlocked ? "border-red-400 focus:ring-red-500 focus:border-red-500" : "border-slate-300 focus:ring-orange-500 focus:border-orange-500"}`}
                />

                {rateBlocked && (
                  <p className="text-xs text-red-600 mt-1.5 font-medium">
                    ⚠️ Kat Mülkiyeti Kanunu md. 20 gereği gecikme faizi aylık %{LEGAL_MAX}'i aşamaz.
                    Daha yüksek bir oran uygulamanız gerekiyorsa bizimle iletişime geçin.
                  </p>
                )}

                {!rateBlocked && capWaived && (
                  <p className="text-xs text-amber-700 mt-1.5">
                    {waiverAcceptedAt
                      ? "Yasal sınır üzeri oran girme yetkiniz aktif. Sorumluluk metnini onayladınız."
                      : `%${LEGAL_MAX} üstü bir oran kaydetmek istediğinizde yasal sorumluluk onayı istenecektir.`}
                  </p>
                )}

                <p className="text-xs text-slate-500 mt-1.5">
                  Basit usul: Her fatura kendi döneminden 1 ay sonra faizlenmeye başlar (Ocak faturası → Mart'ta 1 aylık faiz).
                  Faiz = anapara × oran × gecikilen ay sayısı.
                </p>
              </div>
            )}
          </div>
        </div>

        {/* ── YÖNETİCİ İLETİŞİM BİLGİLERİ ── */}
        <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
          <div className="px-5 py-4 border-b border-slate-100 flex items-center justify-between">
            <div>
              <h2 className="font-semibold text-slate-800">📇 Yönetici İletişim Bilgileri</h2>
              <p className="text-xs text-slate-500 mt-0.5">Sakinlerin kendi panelinde görebileceği iletişim kartı</p>
            </div>
            {!contactEditMode ? (
              <button onClick={() => setContactEditMode(true)} className="flex items-center gap-1.5 text-emerald-600 hover:text-emerald-800 text-sm font-medium border border-emerald-200 px-3 py-1.5 rounded-lg hover:bg-emerald-50">
                <Icon.Edit /> Düzenle
              </button>
            ) : (
              <div className="flex gap-2">
                <button onClick={() => { setContactEditMode(false); setError(""); fetchSettings(); }} className="text-sm text-slate-600 px-3 py-1.5 rounded-lg border border-slate-300 hover:bg-slate-50">İptal</button>
                <button onClick={handleSaveContact} disabled={savingContact} className="flex items-center gap-1.5 bg-emerald-600 hover:bg-emerald-700 disabled:opacity-60 text-white text-sm font-medium px-3 py-1.5 rounded-lg">
                  {savingContact ? <span className="w-3 h-3 border-2 border-white border-t-transparent rounded-full animate-spin" /> : contactSaved ? <Icon.Check /> : <Icon.Save />}
                  {savingContact ? "Kaydediliyor..." : contactSaved ? "Kaydedildi!" : "Kaydet"}
                </button>
              </div>
            )}
          </div>

          <div className="p-5 space-y-4">
            <div className="flex items-center gap-3 p-3 bg-slate-50 rounded-lg">
              <input
                type="checkbox"
                id="contact_enabled"
                checked={contactEnabled}
                onChange={(e) => setContactEnabled(e.target.checked)}
                disabled={!contactEditMode}
                className="w-5 h-5 cursor-pointer"
              />
              <label htmlFor="contact_enabled" className="text-sm font-medium cursor-pointer select-none">
                İletişim bilgilerimi sakinlere göster
              </label>
              {!contactEditMode && (
                <span className={`ml-auto text-sm font-semibold ${contactEnabled ? "text-emerald-600" : "text-slate-400"}`}>
                  {contactEnabled ? "Görünür" : "Gizli"}
                </span>
              )}
            </div>

            <div className="grid sm:grid-cols-2 gap-4">
              <div className="sm:col-span-2">
                <label className="block text-sm font-medium text-slate-700 mb-1.5">Ad Soyad</label>
                <input
                  type="text" value={contactName} onChange={(e) => setContactName(e.target.value)}
                  disabled={!contactEditMode} placeholder="ör: Ahmet Yılmaz"
                  className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 disabled:bg-slate-50 disabled:text-slate-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1.5">Telefon</label>
                <input
                  type="text" value={contactPhone} onChange={(e) => setContactPhone(e.target.value)}
                  disabled={!contactEditMode} placeholder="ör: 0532 000 00 00"
                  className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 disabled:bg-slate-50 disabled:text-slate-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1.5">E-posta</label>
                <input
                  type="email" value={contactEmail} onChange={(e) => setContactEmail(e.target.value)}
                  disabled={!contactEditMode} placeholder="ör: yonetim@apartman.com"
                  className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 disabled:bg-slate-50 disabled:text-slate-500"
                />
              </div>
            </div>

            <p className="text-xs text-slate-500">
              Kapalıyken bu bilgiler sakinlere hiçbir şekilde gönderilmez. Dilerseniz kişisel numaranız yerine
              site iletişim hattını yazabilirsiniz.
            </p>
          </div>
        </div>

        {/* ── DAİRE TİPLERİ ── */}
        <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
          <div className="px-5 py-4 border-b border-slate-100 flex items-center justify-between">
            <div>
              <h2 className="font-semibold text-slate-800">🏠 Daire Tipleri</h2>
              <p className="text-xs text-slate-500 mt-0.5">Daire eklerken seçilecek tipler ve aidat katsayıları</p>
            </div>
            {!typesEditMode ? (
              <button onClick={() => setTypesEditMode(true)} className="flex items-center gap-1.5 text-blue-600 hover:text-blue-800 text-sm font-medium border border-blue-200 px-3 py-1.5 rounded-lg hover:bg-blue-50">
                <Icon.Edit /> Düzenle
              </button>
            ) : (
              <div className="flex gap-2">
                <button onClick={() => { setTypesEditMode(false); fetchSettings(); }} className="text-sm text-slate-600 px-3 py-1.5 rounded-lg border border-slate-300 hover:bg-slate-50">İptal</button>
                <button onClick={handleSaveTypes} disabled={savingTypes} className="flex items-center gap-1.5 bg-blue-600 hover:bg-blue-700 disabled:opacity-60 text-white text-sm font-medium px-3 py-1.5 rounded-lg">
                  {savingTypes ? <span className="w-3 h-3 border-2 border-white border-t-transparent rounded-full animate-spin" /> : typesSaved ? <Icon.Check /> : <Icon.Save />}
                  {savingTypes ? "Kaydediliyor..." : typesSaved ? "Kaydedildi!" : "Kaydet"}
                </button>
              </div>
            )}
          </div>

          <div className="divide-y divide-slate-100">
            {unitTypes.length === 0 ? (
              <div className="py-8 text-center text-slate-400 text-sm">
                <p className="text-2xl mb-2">🏘️</p>
                Henüz daire tipi eklenmemiş. Ekleyin ve dairelere atayın.
              </div>
            ) : (
              unitTypes.map((type, index) => (
                <div key={index} className="flex items-center gap-3 px-5 py-3 hover:bg-slate-50">
                  <span className="text-xs font-mono text-slate-400 w-5 text-center">{index + 1}</span>
                  {typesEditMode ? (
                    <input
                      value={type.name}
                      onChange={(e) => updateUnitType(index, "name", e.target.value)}
                      className="flex-1 px-2 py-1 text-sm border border-slate-300 rounded focus:ring-2 focus:ring-blue-500"
                    />
                  ) : (
                    <span className="flex-1 text-sm font-medium text-slate-800">{type.name}</span>
                  )}
                  <div className="flex items-center gap-2">
                    <span className="text-xs text-slate-500">Katsayı:</span>
                    {typesEditMode ? (
                      <input
                        type="number"
                        value={type.coefficient}
                        onChange={(e) => updateUnitType(index, "coefficient", e.target.value)}
                        step="0.05" min="0.1"
                        className="w-20 px-2 py-1 text-sm border border-slate-300 rounded focus:ring-2 focus:ring-blue-500 text-center"
                      />
                    ) : (
                      <span className={`px-2 py-0.5 rounded text-xs font-semibold ${type.coefficient === 1.0 ? 'bg-slate-100 text-slate-600' : 'bg-blue-100 text-blue-700'}`}>
                        ×{Number(type.coefficient).toFixed(2)}
                      </span>
                    )}
                  </div>
                  {!typesEditMode && totalAmount > 0 && (
                    <span className="text-sm font-bold text-slate-700 w-24 text-right">
                      ₺{(totalAmount * type.coefficient).toLocaleString("tr-TR", { minimumFractionDigits: 0 })}
                    </span>
                  )}
                  {typesEditMode && (
                    <button onClick={() => removeUnitType(index)} className="text-slate-300 hover:text-red-500 p-1 rounded">
                      <Icon.Trash />
                    </button>
                  )}
                </div>
              ))
            )}
          </div>

          {typesEditMode && (
            <div className="px-5 py-4 border-t border-blue-100 bg-blue-50">
              <p className="text-xs font-semibold text-blue-700 uppercase tracking-wide mb-3">Yeni Tip Ekle</p>
              <div className="flex gap-2">
                <input
                  type="text"
                  placeholder="ör: 3+1 Daire, Dükkan, Ofis..."
                  value={newTypeName}
                  onChange={(e) => setNewTypeName(e.target.value)}
                  onKeyDown={(e) => e.key === "Enter" && addUnitType()}
                  className="flex-1 px-3 py-2 text-sm border border-blue-200 rounded-lg bg-white focus:ring-2 focus:ring-blue-500"
                />
                <div className="relative w-36">
                  <span className="absolute left-2 top-1/2 -translate-y-1/2 text-slate-400 text-xs">×</span>
                  <input
                    type="number"
                    placeholder="Katsayı"
                    value={newTypeCoeff}
                    onChange={(e) => setNewTypeCoeff(e.target.value)}
                    onKeyDown={(e) => e.key === "Enter" && addUnitType()}
                    step="0.05" min="0.1"
                    className="w-full pl-6 pr-2 py-2 text-sm border border-blue-200 rounded-lg bg-white focus:ring-2 focus:ring-blue-500"
                  />
                </div>
                <button
                  onClick={addUnitType}
                  disabled={!newTypeName.trim() || !newTypeCoeff}
                  className="flex items-center gap-1.5 bg-blue-600 hover:bg-blue-700 disabled:opacity-40 text-white text-sm font-medium px-3 py-2 rounded-lg"
                >
                  <Icon.Plus /> Ekle
                </button>
              </div>
              {newTypeName && newTypeCoeff && totalAmount > 0 && (
                <p className="text-xs text-blue-600 mt-2">
                  Önizleme: {newTypeName} → ₺{(totalAmount * (parseFloat(newTypeCoeff) || 0)).toLocaleString("tr-TR", { minimumFractionDigits: 0 })} / ay
                </p>
              )}
            </div>
          )}

          {unitTypes.length > 0 && !typesEditMode && (
            <div className="px-5 py-3 bg-slate-50 border-t border-slate-100 text-xs text-slate-500">
              Temel aidat ₺{totalAmount.toLocaleString("tr-TR")} üzerinden hesaplanmıştır. Daire eklerken bu tiplerden birini seçin.
            </div>
          )}
        </div>

        {/* ── DÖNEM AYARLARI ── */}
        <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
          <div className="px-5 py-4 border-b border-slate-100">
            <h2 className="font-semibold text-slate-800 flex items-center gap-2"><Icon.Calendar /> Dönem Ayarları</h2>
          </div>
          <div className="p-5 grid sm:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1.5">Ödeme Dönemi</label>
              <select value={period} onChange={(e) => setPeriod(e.target.value)} disabled={!editMode} className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm disabled:bg-slate-50 disabled:text-slate-500">
                <option value="monthly">Aylık</option>
                <option value="quarterly">3 Aylık</option>
                <option value="yearly">Yıllık</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1.5">Son Ödeme Günü</label>
              <select value={dueDay} onChange={(e) => setDueDay(Number(e.target.value))} disabled={!editMode} className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm disabled:bg-slate-50 disabled:text-slate-500">
                {Array.from({ length: 28 }, (_, i) => i + 1).map(d => (
                  <option key={d} value={d}>Her ayın {d}. günü</option>
                ))}
              </select>
            </div>
          </div>
        </div>

        {/* ── AİDAT KALEMLERİ ── */}
        <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
          <div className="px-5 py-4 border-b border-slate-100 flex items-center justify-between">
            <h2 className="font-semibold text-slate-800 flex items-center gap-2"><Icon.TurkishLira /> Aidat Kalemleri</h2>
            <span className="text-xs text-slate-500">{items.length} kalem</span>
          </div>
          <div className="divide-y divide-slate-100">
            {items.length === 0 ? (
              <div className="py-10 text-center text-slate-400 text-sm"><p className="text-2xl mb-2">📋</p>Henüz kalem eklenmemiş</div>
            ) : (
              items.map((item, index) => (
                <div key={index} className="flex items-center gap-3 px-5 py-3 hover:bg-slate-50">
                  <span className="text-xs font-mono text-slate-400 w-5 text-center">{index + 1}</span>
                  {editMode ? (
                    <input value={item.name} onChange={(e) => updateItem(index, "name", e.target.value)} className="flex-1 px-2 py-1 text-sm border border-slate-300 rounded focus:ring-2 focus:ring-blue-500" />
                  ) : (
                    <span className="flex-1 text-sm font-medium text-slate-800">{item.name}</span>
                  )}
                  {editMode ? (
                    <div className="relative w-32">
                      <span className="absolute left-2 top-1/2 -translate-y-1/2 text-slate-400 text-xs">₺</span>
                      <input type="number" value={item.amount} min="0" onChange={(e) => updateItem(index, "amount", e.target.value)} className="w-full pl-6 pr-2 py-1 text-sm border border-slate-300 rounded focus:ring-2 focus:ring-blue-500 text-right" />
                    </div>
                  ) : (
                    <span className="text-sm font-semibold text-slate-900 w-20 text-right">₺{Number(item.amount).toLocaleString("tr-TR")}</span>
                  )}
                  <div className="hidden sm:flex items-center gap-1.5 w-24">
                    <div className="flex-1 bg-slate-100 rounded-full h-1.5 overflow-hidden">
                      <div className="bg-blue-500 h-1.5 rounded-full transition-all duration-500" style={{ width: totalAmount > 0 ? `${(item.amount / totalAmount) * 100}%` : "0%" }} />
                    </div>
                    <span className="text-xs text-slate-400 w-8 text-right">{totalAmount > 0 ? Math.round((item.amount / totalAmount) * 100) : 0}%</span>
                  </div>
                  {editMode && (
                    <button onClick={() => removeItem(index)} className="text-slate-300 hover:text-red-500 p-1 rounded"><Icon.Trash /></button>
                  )}
                </div>
              ))
            )}
          </div>
          <div className="px-5 py-4 bg-slate-50 border-t border-slate-200 flex items-center justify-between">
            <div className="flex items-center gap-2 text-sm text-slate-500"><Icon.Info />Temel tutar × daire tipi katsayısı</div>
            <div className="text-right">
              <p className="text-xs text-slate-500 uppercase tracking-wide">Temel Aidat</p>
              <p className="text-xl font-bold text-slate-900">₺{totalAmount.toLocaleString("tr-TR")}</p>
            </div>
          </div>
          {editMode && (
            <div className="px-5 py-4 border-t border-blue-100 bg-blue-50">
              <p className="text-xs font-semibold text-blue-700 uppercase tracking-wide mb-3">Yeni Kalem Ekle</p>
              <div className="flex gap-2">
                <input type="text" placeholder="Kalem adı (ör: Asansör Bakımı)" value={newItemName} onChange={(e) => setNewItemName(e.target.value)} onKeyDown={(e) => e.key === "Enter" && addItem()} className="flex-1 px-3 py-2 text-sm border border-blue-200 rounded-lg bg-white focus:ring-2 focus:ring-blue-500" />
                <div className="relative w-32">
                  <span className="absolute left-2 top-1/2 -translate-y-1/2 text-slate-400 text-sm">₺</span>
                  <input type="number" placeholder="Tutar" value={newItemAmount} min="0" onChange={(e) => setNewItemAmount(e.target.value)} onKeyDown={(e) => e.key === "Enter" && addItem()} className="w-full pl-6 pr-2 py-2 text-sm border border-blue-200 rounded-lg bg-white focus:ring-2 focus:ring-blue-500" />
                </div>
                <button onClick={addItem} disabled={!newItemName.trim() || !newItemAmount} className="flex items-center gap-1.5 bg-blue-600 hover:bg-blue-700 disabled:opacity-40 text-white text-sm font-medium px-3 py-2 rounded-lg">
                  <Icon.Plus /> Ekle
                </button>
              </div>
            </div>
          )}
        </div>

        {/* Geçmiş */}
        {history.length > 0 && (
          <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
            <button onClick={() => setShowHistory(v => !v)} className="w-full px-5 py-4 flex items-center justify-between text-left hover:bg-slate-50">
              <h2 className="font-semibold text-slate-800">Bu Oturumda Yapılan Değişiklikler</h2>
              <span className="text-slate-400 text-sm">{showHistory ? "▲ Gizle" : "▼ Göster"}</span>
            </button>
            {showHistory && (
              <div className="divide-y divide-slate-100 border-t border-slate-100">
                {history.map((h, i) => (
                  <div key={i} className="px-5 py-3 text-sm">
                    <div className="flex items-center justify-between mb-1">
                      <span className="text-slate-500 text-xs">{h.date}</span>
                      <span className="font-semibold text-slate-800">₺{h.total.toLocaleString("tr-TR")}</span>
                    </div>
                    <div className="text-xs text-slate-400">{h.items.map(item => `${item.name}: ₺${item.amount}`).join(" · ")}</div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {/* Uyarı */}
        <div className="bg-amber-50 border border-amber-200 rounded-xl px-5 py-4 flex gap-3">
          <Icon.Warning />
          <div className="text-sm text-amber-800">
            <p className="font-semibold mb-1">Önemli Hatırlatma</p>
            <p>Aidat ayarlarını değiştirdikten sonra yeni fatura oluştururken güncel kalemler kullanılır. Mevcut faturalar bu değişiklikten etkilenmez.</p>
          </div>
        </div>
      </div>

      {/* ── YASAL SORUMLULUK ONAY MODALI ── */}
      {showWaiverModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl w-full max-w-2xl max-h-[90vh] flex flex-col shadow-2xl">
            <div className="px-6 py-4 border-b border-slate-200">
              <h3 className="font-semibold text-lg text-slate-800">Yasal Sorumluluk Onayı</h3>
              <p className="text-xs text-slate-500 mt-0.5">Yasal sınır üzeri gecikme faizi uygulaması</p>
            </div>

            <div className="px-6 py-4 overflow-y-auto flex-1">
              <div className="bg-red-50 border border-red-200 rounded-xl p-4 mb-4">
                <p className="text-sm text-red-800">
                  Girmek istediğiniz oran <strong>%{feeRate}</strong>, Kat Mülkiyeti Kanunu md. 20'de
                  öngörülen aylık <strong>%{LEGAL_MAX}</strong> sınırının üzerindedir.
                </p>
              </div>

              {/* TODO: Sözleşme metni buraya eklenecek */}
              <div className="border border-slate-200 rounded-xl p-4 text-sm text-slate-600 leading-relaxed max-h-56 overflow-y-auto bg-slate-50">
                <p className="font-semibold text-slate-800 mb-2">Sözleşme Metni</p>
                <p className="mb-2">
                  Yasal sınır üzerinde gecikme faizi uygulanmasına ilişkin tüm hukuki sorumluluk site
                  yönetimine aittir. Bu tercihin yönetim planına veya kat malikleri kurulu kararına
                  dayanması gerekmektedir.
                </p>
                <p className="text-xs text-slate-400 italic">(Sözleşme metninin tamamı daha sonra eklenecektir.)</p>
              </div>

              <label className="flex items-start gap-2 mt-4 cursor-pointer">
                <input
                  type="checkbox"
                  checked={waiverChecked}
                  onChange={(e) => setWaiverChecked(e.target.checked)}
                  className="w-4 h-4 mt-0.5"
                />
                <span className="text-sm text-slate-700">
                  Yukarıdaki yasal uyarıyı okudum, anladım ve sorumluluğu kabul ediyorum.
                </span>
              </label>
            </div>

            <div className="px-6 py-4 border-t border-slate-200 flex gap-3 justify-end">
              <button
                onClick={() => { setShowWaiverModal(false); setWaiverChecked(false); }}
                className="px-4 py-2 border border-slate-300 rounded-lg text-sm text-slate-600 hover:bg-slate-50"
              >
                Vazgeç
              </button>
              <button
                onClick={handleAcceptWaiver}
                disabled={!waiverChecked || acceptingWaiver}
                className="px-4 py-2 bg-red-600 hover:bg-red-700 disabled:opacity-40 disabled:cursor-not-allowed text-white rounded-lg text-sm font-semibold"
              >
                {acceptingWaiver ? "Kaydediliyor..." : "Kabul Ediyorum ve Kaydet"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function SummaryCard({ label, value, color }) {
  const colors = {
    blue:   "bg-blue-50 border-blue-200 text-blue-700",
    purple: "bg-purple-50 border-purple-200 text-purple-700",
    amber:  "bg-amber-50 border-amber-200 text-amber-700",
    emerald:"bg-emerald-50 border-emerald-200 text-emerald-700",
    red:    "bg-red-50 border-red-200 text-red-700",
    slate:  "bg-slate-50 border-slate-200 text-slate-600",
  };
  return (
    <div className={`rounded-xl border px-4 py-3 ${colors[color] || colors.slate}`}>
      <p className="text-xs opacity-70 mb-1">{label}</p>
      <p className="font-bold text-base">{value}</p>
    </div>
  );
}